import { Controller } from "@hotwired/stimulus";

// The PDF can take a few seconds to make the first time, so the button says so instead of seeming dead
export default class extends Controller {
  static targets = ["button", "label"];

  start() {
    const original = this.labelTarget.textContent;
    this.labelTarget.textContent = "Making your PDF...";
    this.buttonTarget.classList.add("pointer-events-none", "opacity-70");

    setTimeout(() => {
      this.labelTarget.textContent = original;
      this.buttonTarget.classList.remove("pointer-events-none", "opacity-70");
    }, 6000);
  }
}
